import { Text } from "@/atoms"
import { LoadingOutlined } from "@/icons"
import { NotificationTemplate } from "./NotificationTemplate"

import styles from "./NotificationTemplate.module.scss"

import type { NotificationProps } from "./open-pr.types"

export const RunningNotification = (props: NotificationProps) => (
  <NotificationTemplate
    icon={<LoadingOutlined spin className={styles.iconInfo} />}
    buttonText={props.actions.t("general.view")}
    buttonProps={{ loading: true, disabled: true }}
    text={props.getText("notifications.prTask.opening.title", props)}
  >
    {[1, 2].map((index) => (
      <Text key={index}>
        {props.getText(
          `notifications.prTask.opening.line${index}`,
          props,
          "notifications.prTask.typeFull"
        )}
      </Text>
    ))}
  </NotificationTemplate>
)
